import type { Account, AccountShapeFull } from 'mastodon/models/account';
import { getAreaEngName, getAreaShortName } from 'mastodon/utils/area';

interface Props {
  account: Account | AccountShapeFull;
}

export const AreaAvatar = ({ account }: Props) => (
  <div className='account__avatar__area-wrapper'>
    <span className={'account__avatar__area-' + getAreaEngName(account)}>
      {getAreaShortName(account)}
    </span>
  </div>
);
